import { render, staticRenderFns } from "./DeliveryOrderDetailInput.vue?vue&type=template&id=a83fe4f6&scoped=true&"
import script from "./DeliveryOrderDetailInput.vue?vue&type=script&lang=js&"
export * from "./DeliveryOrderDetailInput.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryOrderDetailInput.vue?vue&type=style&index=0&id=a83fe4f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83fe4f6",
  null
  
)

export default component.exports